import { googleLogout } from "@react-oauth/google";

/**
 * Google OAuth configuration
 * Client ID is loaded from environment variable
 */
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const API_URL = process.env.REACT_APP_API_URL || "/api";

/**
 * Check if Google OAuth is configured
 * @returns {boolean}
 */
export function isGoogleOAuthConfigured() {
  return !!GOOGLE_CLIENT_ID;
}

/**
 * Get the Google Client ID
 * @returns {string|null}
 */
export function getGoogleClientId() {
  return GOOGLE_CLIENT_ID || null;
}

/**
 * Get the Google OAuth authorization URL for redirect flow
 * @returns {Promise<string|null>}
 */
export async function getGoogleAuthUrl() {
  if (!GOOGLE_CLIENT_ID) return null;

  try {
    // Fetch the OAuth URL from our backend
    const response = await fetch(
      `${API_URL}/auth/google/url?origin=${encodeURIComponent(window.location.origin)}`,
    );
    if (!response.ok) {
      throw new Error("Failed to get OAuth URL");
    }
    const data = await response.json();
    return data.url;
  } catch (error) {
    console.error("Error getting Google auth URL:", error);
    return null;
  }
}

/**
 * Sign out from Google (clears the Google cookie)
 */
export async function signOutGoogle() {
  try {
    googleLogout();
  } catch (error) {
    console.error("Google logout error:", error);
  }
}

export { GOOGLE_CLIENT_ID };
